import React from 'react';
import './ReactTableStyles.scss'
import ReactBaseTable, {DefaultTableProps, FilterOptions} from "./ReactBaseTable";
import {Row} from "@tanstack/react-table";

type SyncTableProps<T extends object> = {
    data: T[];
    isLoading: boolean;
    enableColumnResizing?: boolean;
    enableColumnGrouping?: boolean;
    initialSortColumn?: string;
    filterOptions: FilterOptions
    defaultExpandedGroups?: boolean;
    rowColorCallback?: (row: Row<T>) => string;
} & DefaultTableProps<T>;

const ReactSyncTable = <T extends object>({
    data,
    columns,
    title,
    isLoading,
    filterOptions,
    enableColumnGrouping = true,
    enableColumnResizing = true,
    defaultExpandedGroups = true,
    rowColorCallback
}: SyncTableProps<T>) => {

    return (<ReactBaseTable
        title={title}
        data={data}
        columns={columns}
        isAsync={false}
        filterOptions={filterOptions}
        isLoading={isLoading}
        enableColumnGrouping={enableColumnGrouping}
        enableColumnResizing={enableColumnResizing}
        defaultExpandedGroups={defaultExpandedGroups}
        rowColorCallback={rowColorCallback}
    />);
};

export default ReactSyncTable;
